// components/modals/ProductInfoModal.js
import React from 'react';
import { Descriptions, Divider, Flex, Image, Modal, Table, Tag, Typography } from 'antd';
import { wms_uploads_cdn, env } from '../../Components/config';
import { useSelector } from 'react-redux';
import { locationTypes } from '../common/Constants';
import InfoCards from '../InfoCards';
import { NumberOutlined } from '@ant-design/icons';
import DetailsGrid from '../common/DetailsGrid';
import dayjs from 'dayjs';

const ProductInfoModal = ({
    visible,
    onCancel,
    selectedItemDetails,
    selectedItems,
    selectedRecord,
}) => {
    const { code, name } = selectedItemDetails || {};
    const { locations } = useSelector((state) => state?.AppState?.userCreds);

    const columns = [
        {
            title: 'Location',
            render: (record) => {
                console.log('record', record);

                const selected = locations?.find((item) => item.id == record?.location_id)
                return (
                   <>
                               <Flex gap={4}>
                               {selected?.is_picking > 0 ? (
                                <>
                                    <Tag color="green" >Picking</Tag>
                                   {!!selected?.is_frontdesk_picking && <Tag color="purple" >Front Desk Picking</Tag>}
                                 </>
                               ) :  null}
                               {selected?.is_binning > 0 ? (
                                 <Tag color="warning" >Binning</Tag>
                               ) :  null}
                               {selected?.is_transit > 0 ? (
                                 <Tag color="red" >Transit</Tag>
                               ) :  null}
                               {selected?.code}
                               </Flex>
                   
                               
                             </>
                );
            }
        },
        // {
        //     title: 'Location Type',
        //     render: (record) => {
        //         const selected = locations?.find((item) => item.id == record?.location_id)
        //         const selectedType = selected?.type ? locationTypes?.find((item) => item.id == selected?.type) : null;

        //         return (
        //             <>
        //                 {selectedType?.title || ''}
        //             </>
        //         );
        //     }
        // },
        {
            title: 'Pallet Quantity',
            align: 'center',
            render: (record) => {
                const stockLevel = record?.stock_level || 0;
                const casesInPallets = record?.cases_in_pallets || 0;
                const numberOfPallets =
                    stockLevel > 0 && casesInPallets > 0
                        ? (stockLevel / casesInPallets).toFixed(2)
                        : '0.00';
                return (
                    <>
                        {numberOfPallets.toLocaleString() }

                    </>
                );
            }
        },
        {
            title: 'Quantity',
            align: 'center',
            render: (record) => {
                return (
                    <>
                        <Tag color={record?.stock_level > 0  ? 'green' : 'blue'} style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.stock_level ? record?.stock_level.toLocaleString() : 0} </Tag><br />
                    </>
                );
            }
        },
        
        {
            title: 'Batch Code',
            render: (record) => {
                return (
                    <>
                        {record?.supplier_batch_code || ''}
                    </>
                );
            }
        },
         {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{dayjs(expiry)?.format('DD-MM-YYYY')}</Tag>;
              }
            },

    ];

      const infoItems = [
    {
      label: 'Pallet Quantity',
      value: (() => {
                const totalStock = selectedItemDetails?.totalStock || 0;
                const casesInPallet = selectedItems?.[0]?.cases_in_pallets || 0;
                if (totalStock > 0 && casesInPallet > 0) {
                    const pallets = totalStock / casesInPallet;
                    return pallets.toFixed(2);
                }
                return '0.00';
            })(),
      type: 'text', 
      icon: <NumberOutlined style={{ color: "#0958d9" }} />,
      color: '#0958d9'

    },
    {
      label: 'Total Quantity',
      value:  selectedItemDetails?.totalStock ? selectedItemDetails?.totalStock.toLocaleString() : '0',
      type: 'text',
      icon: <NumberOutlined style={{ color: "green" }} />,
      color: 'green'

    },
    
  ]

    return (
        <Modal
            width={'70vw'}
            title={`${code} - ${name}`}
            open={visible}
            onCancel={onCancel}
            cancelText="Close"
            style={{ top: 20 }}
            okButtonProps={{ style: { display: 'none'}, }}
        >
            <Divider style={{ margin: '2px 2px' }} />
            <Flex justify='end' style={{ marginBlock: 8 }}>
            <Tag 
                color='blue'               
                style={{
                borderRadius: "6px",
                padding: "4px 12px",
                fontWeight: 500,
                fontSize: "14px",
                margin: 0
              }}>
                {`Cases In Pallets: ${selectedItems[0]?.cases_in_pallets ? selectedItems[0]?.cases_in_pallets.toLocaleString() : 0}`}
            </Tag>
            </Flex>
            {/* <InfoCards items={modalInfoItems} maxColumns={2} /> */}
            <DetailsGrid infoItems={infoItems} />


            <Image.PreviewGroup>
                {selectedRecord?.gallery_images?.length > 0 &&
                    JSON.parse(selectedRecord?.gallery_images)?.slice(0, 3)?.map((item, index) => {
                        const imageUrl = `${wms_uploads_cdn}/${env}/warehouse-products/${selectedRecord?.netsuite_id}/${item.replace(/\+/g, '%2B')}`;
                        return (
                            <div key={index} style={{ marginRight: 10, display: 'inline-block' }}>
                                <Image
                                    width={150}
                                    height={100}
                                    style={{ padding: 5, border: '1px solid lightgrey' }}
                                    src={imageUrl}
                                />
                            </div>
                        );
                    })}
            </Image.PreviewGroup>

            <Typography.Title level={5} style={{ marginTop: 20 }}>
                Stock Details
            </Typography.Title>

            <Table
                dataSource={selectedItems?.filter((item) => item?.location_id)}
                columns={columns}
                pagination={false}
                rowKey={(record, index) => index}
                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
            />
        </Modal>
    );
};

export default ProductInfoModal;
